module.exports = __webpack_public_path__ + "img/goods12-1.405c8853.jpg";